import { SNAPSHOT_METRIC } from '@witmetrics/utils/constants';
import { METRIC_VALUE_KIND } from '@/constants/metrics';
import type { OverviewMetricDefinition } from './types';

const { NEW_LEADS, LEAD_TO_SALE_CONVERSION } = SNAPSHOT_METRIC;
const { COUNT, RATE, COMPACT_PRICE } = METRIC_VALUE_KIND;

export const OVERVIEW_METRIC = {
  REVENUE_ACCEPTED: 'REVENUE_ACCEPTED',
  ACCEPTED_PATIENTS: 'ACCEPTED_PATIENTS',
  NEW_LEADS,
  LEAD_TO_SALE_CONVERSION,
} as const;

export const KEY_METRICS: OverviewMetricDefinition[] = [
  {
    key: OVERVIEW_METRIC.REVENUE_ACCEPTED,
    label: 'Revenue accepted',
    kind: COMPACT_PRICE,
  },
  {
    key: OVERVIEW_METRIC.ACCEPTED_PATIENTS,
    label: 'Accepted patients',
    kind: COUNT,
  },
  { key: OVERVIEW_METRIC.NEW_LEADS, label: 'New leads', kind: COUNT },
  {
    key: OVERVIEW_METRIC.LEAD_TO_SALE_CONVERSION,
    label: 'Lead → sale conversion',
    kind: RATE,
  },
];

export const KEY_METRIC_SNAPSHOTS = [NEW_LEADS, LEAD_TO_SALE_CONVERSION];

export const TOP_TREATMENTS_LIMIT = 5;
